const en = {
  "Contact us": "Contact us",
  "Your email address": "Your email address",
  "Your message": "Your message",
  Send: "Send",
  "New message": "New message",
  "About us": "About us",
  Photo: "Photo",
  Photos: "Photos",
  "Hero image": "Hero image",
  "Frequently asked questions": "Frequently asked questions",
  "This site is protected by": "This site is protected by",
  "reCAPTCHA privacy conjunction": "and Google’s",
  "Privacy Policy": "Privacy Policy",
  "reCAPTCHA terms conjunction": "and",
  "Terms of Service": "Terms of Service",
  "reCAPTCHA legal suffix": "apply.",
  "Thank you for your interest! We will get back to you as soon as possible.":
    "Thank you for your interest! We will get back to you as soon as possible.",
};

const fr = {
  "Contact us": "Contactez-nous",
  "Your email address": "Votre e-mail",
  "Your message": "Votre message",
  Send: "Envoyer",
  "New message": "Nouveau message",
  "About us": "À propos",
  Photo: "Photo",
  Photos: "Photos",
  "Hero image": "Image principale",
  "Frequently asked questions": "Questions fréquentes",
  "This site is protected by": "Ce site est protégé par",
  "reCAPTCHA privacy conjunction": "et la",
  "Privacy Policy": "politique de confidentialité",
  "reCAPTCHA terms conjunction": "et les",
  "Terms of Service": "conditions d’utilisation",
  "reCAPTCHA legal suffix": "de Google s’appliquent.",
  "Thank you for your interest! We will get back to you as soon as possible.":
    "Nous vous remercions de votre intérêt ! Nous vous répondrons dans les plus brefs délais.",
} satisfies { [K in keyof typeof en]: string };

export const I18n = (lang: "en" | "fr" | string = "en"): typeof en =>
  ({ en, fr }[lang] || en);
